import { render, staticRenderFns } from "./DownloadMobile.vue?vue&type=template&id=c98eecae&scoped=true"
import script from "./DownloadMobile.vue?vue&type=script&lang=js"
export * from "./DownloadMobile.vue?vue&type=script&lang=js"
import style0 from "./DownloadMobile.vue?vue&type=style&index=0&id=c98eecae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98eecae",
  null
  
)

export default component.exports